import React from 'react';
import './footer.css';

class Footer extends React.Component {
  render() {
    const data = require('../../other.json');
    return (
      <div className="footer">
        <div className="footer__images">
          {data.footer.museums.map((element, index) => (
            <div
              className="footer__image"
              key={index}
              style={{ backgroundImage: `url(./images/footer/${element})` }}
            />
          ))}
        </div>
        <div className="footer__links">
          <div className="footer__share">Поделиться</div>
          <div className="footer__external-links">
            {[
              {
                name: 'Одноклассники',
                link: data.footer.link1
              },
              {
                name: 'Вконтакте',
                link: data.footer.link3
              }
            ].map((element, index) => (
              <a
                className="link"
                href={`${element.link}`}
                key={index}
                rel="noopener noreferrer"
                target="_blank"
              >
                <div className="footer__link">{element.name}</div>
              </a>
            ))}
          </div>
        </div>
        <div className="footer__info">
          <div className="footer__share">О проекте</div>
          <a
            className="link"
            href="https://museum.ok.ru/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <div className="footer__link">Мы в музей</div>
          </a>
        </div>
        {/* <div className="footer__copyright">
          Авторские права: © Google Art Project, Королевский музей
          изобразительных искусств Бельгия, Брюссель / © www.lukasweb.be -
          Искусство во Фландрии vzw / © Rubens House, Антверпен / © RMFAB,
          Брюссель фото J. Geleyns - Ro scan / © Музей Майера Ван ден Берг, фото
          KIK-IRPA / © Королевский музей изобразительных искусств Бельгия, Йохан
          Гелайнс / © Королевские музеи изобразительных искусств Бельгия,
          Брюссель фото J. Geleyns - Ro scan
        </div> */}
      </div>
    );
  }
}

export default Footer;
